<template>
    <div class="preloader" v-show="loader">
        <div class="lds-ellipsis">
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div v-if="downloaded !== ''" class="preloader-info">
            {{downloaded}}
        </div>
        <div v-if="progress > 0" class="preloader-progress">
            <div :style="'width:'+progress+'%'"></div>
        </div>
    </div>
</template>

<script>

    import tools from '../config.ts';
    import Btn from "@/components/Btn";
    import Loader from "@/components/Loader";

    export default {
        name: "Loader",
        components: {Loader, Btn},
        data() {
            return {
                loader:false,
                downloaded:"",
                progress:0
            }
        },

        mounted() {

            tools.$on("loader", (active) => {
                this.loader = active

                if(!this.loader){
                    this.downloaded = ""
                    this.progress = 0
                }
            });
            tools.$on("loader-download", (value) => {
                this.downloaded = value
            });
            tools.$on("loader-progress", (value) => {
                this.progress = value
            });
        }
    }
</script>